<template>
	<v-layout column>	
		<BldgPhoto />
		<v-data-table :items="buildingItems" hide-actions hide-headers class="mt-3">
			<template slot="items" slot-scope="props">
				<tr class="bc_tablerow_height">
					<td>{{ props.item.label }}</td>
					<td class="text-xs-right">{{ props.item.val }}</td>
				</tr>
			</template>
  		</v-data-table>
  	</v-layout>
</template>

<script>
import { mapState } from 'vuex'
import BldgPhoto from './BldgPhoto'

let TabBuilding = {
	name: TabBuilding,
	data() {
		return {			
		}
	},
	components: { BldgPhoto },

	computed: {
		...mapState({
			building: state => state.space.selectedBuilding,
			buildingItems: function () {
				if (this.building) {
				return 	[
							{ label: 'Number', val: (this.building.bldgNumber) + " / " + this.building.bldgAlpha },
							{ label: 'Address', val: this.building.address },
							{ label: 'Constructed', val: this.building.dateConstructed },
							{ label: 'Gross SF', val: this.building.grossArea && this.building.grossArea.toLocaleString(undefined, { maximumFractionDigits : 0 }) },
							{ label: 'Assignable SF', val: this.building.assignableArea && this.building.assignableArea.toLocaleString(undefined, { maximumFractionDigits : 0 }) },
							

						]
				}
			}
	  	}),
		bldgPhoto: function () {
			return `http://maps.arizona.edu/photos/buildings/medium/${this.building.bldgAlpha}.jpg`
		},
		error: function() {
			return false
		}
	},
}

export default TabBuilding

</script>
<style>

.bc_tablerow_height td { padding-left: 25px !important; height: 40px !important;}

</style>


// WEBPACK FOOTER //
// src/components/buildingcard/TabBuilding.vue